<ng-container *ngrxLet="isDefaultLayout$ as isDefaultLayout">
  <ng-container *ngIf="isDefaultLayout">
    <div class="container">
      <div
        [ngClass]="{
          'lui-dual-col-default': !wide,
          'lui-dual-col-wide': wide
        }"
      >
        <div class="lui-layout-dual-col-main">
          <div class="lui-layout-dual-col-container">
            <ng-container [ngTemplateOutlet]="main"></ng-container>
          </div>
        </div>
        <div
          class="lui-layout-dual-col-aside"
          [class.lui-layout-dual-col-aside-sticky]="sticky"
        >
          <div class="lui-layout-dual-col-aside-container">
            <ng-container [ngTemplateOutlet]="shared"></ng-container>
            <ng-container [ngTemplateOutlet]="aside"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!isDefaultLayout">
    <lui-drawer-bottom-container>
      <div class="container">
        <ng-container [ngTemplateOutlet]="main"></ng-container>
        <ng-container [ngTemplateOutlet]="shared"></ng-container>
      </div>
      <lui-drawer-bottom #drawerBottom>
        <div luiDrawerBottomPanelContent>
          <div class="hstack gap-1">
            <lui-avatar size="48px" class="me-1">
              <mat-icon [svgIcon]="asideIcon"></mat-icon>
            </lui-avatar>
            <strong>{{ asideTitle }}</strong>
          </div>
        </div>

        <mat-button-toggle
          luiDrawerBottomPanelControl
          luiThemeColor
          color="primary"
          #toggleButton
          (click)="drawerBottom.toggle()"
          class="drawer-toggle"
        >
          <mat-icon
            svgIcon="chevron_down"
            *ngIf="drawerBottom.opened; else closeIcon"
          ></mat-icon>
          <ng-template #closeIcon>
            <mat-icon svgIcon="chevron_up"></mat-icon>
          </ng-template>
        </mat-button-toggle>

        <ng-container
          *ngIf="!drawerContentRef; else drawerContent"
          [ngTemplateOutlet]="aside"
        ></ng-container>
      </lui-drawer-bottom>
    </lui-drawer-bottom-container>
  </ng-container>
</ng-container>

<ng-template #main>
  <ng-content></ng-content>
</ng-template>

<ng-template #aside>
  <ng-content select="[luiLayoutDualColAside]"></ng-content>
</ng-template>

<ng-template #shared>
  <ng-content select="[luiLayoutDualColShared]"></ng-content>
</ng-template>

<ng-template #drawerContent>
  <ng-content select="[luiLayoutDualColDrawerContent]"></ng-content>
</ng-template>
